var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"katex",staticClass:"color-title"},[_c('div',{staticClass:"square",style:({ backgroundColor: _vm.backgroundColor })}),_vm._t("default"),_vm._v(" "+_vm._s(_vm.title)+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }